"use client";

import { CheckCircle2 } from "lucide-react";
import { StaggerContainer, StaggerItem } from "@/components/ui/animated-section";

interface BenefitsGridProps {
 title?: string;
 benefits: string[];
 columns?: 1 | 2 | 3;
}

const cols = {
 1: "",
 2: "md:grid-cols-2",
 3: "md:grid-cols-2 lg:grid-cols-3",
};

export function BenefitsGrid({ title = "Key Benefits", benefits, columns = 2 }: BenefitsGridProps) {
 if (benefits.length === 0) return null;

 return (
 <section className="py-12">
 <h2 className="text-2xl font-bold text-foreground mb-6">{title}</h2>
 <StaggerContainer className={`grid gap-4 ${cols[columns]}`} staggerDelay={0.06}>
 {benefits.map((benefit, i) => (
 <StaggerItem key={i}>
    <div className="group flex items-start gap-3 rounded-xl border p-4 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md backdrop-blur-sm service-accent-border service-accent-soft">
    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg service-accent-soft-strong">
     <CheckCircle2 className="w-4 h-4 text-primary" />
  </div>
  <span className="text-foreground/80 text-sm leading-relaxed pt-1">{benefit}</span>
  </div>
 </StaggerItem>
 ))}
 </StaggerContainer>
 </section>
 );
}
